module.exports = __webpack_public_path__ + "static/media/look.26ecbc5f.png";